import { FC } from 'react';
import { MarkerF } from '@react-google-maps/api';
import { typeCoords } from '@monorepo/models';
import { useGetCurrentPosition } from 'src/custom-hooks';

type propsType = {
    position?: typeCoords;
    showError: boolean;
};

export const MapMarkerCurrentPosition: FC<propsType> = ({ position, showError }) => {
    const currentPosition = position ?? useGetCurrentPosition(false, showError).userCoords;

    if (!currentPosition) {
        return <></>;
    }

    return (
        <MarkerF
            icon={{
                scaledSize: new window.google.maps.Size(40, 40),
                url: 'https://maps.google.com/mapfiles/ms/icons/green-dot.png'
            }}
            position={currentPosition}
        />
    );
}
